<template>
  <div>
    <div v-if="cellData.SurveyWave && getInfo()">
      <div v-for="(entry) in cellData.entries" class="truncate" :key="entry">
        {{ entry.Name }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } }
    };
  },

  methods: {
    getInfo() {
      if (!this.cellData.entries) {
        return false;
      }
      return true;
    },
    checkValue(it) {
      if (it === undefined || it === null) {
        return false;
      }
      return true;
    },
    getWidth(item) {
      return !item.Result || item.Result === 0 ? 0.1 : item.Result;
    },
    getActualWaveTooltip (item) {
      return this.$t('Webportal.CurrentWave') + ' (' + item.Name + ') ' + item.Result + '%';
    },
    getLastWaveTooltip(item) {
      return this.$t('Webportal.PreviousWave') + ' (' + item.Name + ') ' + item.Result + '%';
    }
  }
};

</script>
<style scoped>

.truncate {
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.waves{
  width: 100%;
  height: 2rem;
}
.lw, .aw, .now {
  height: 1rem;
  margin: 1px;
  border-radius: 3px;
}

.now {
  width: 0%;
}

</style>
